// Centralized data for the LT+ site
// Real data from github.com/louistrue

export const LT_BRAND = {
  name: "LTplus AG",
  short: "LT+",
  founded: "2023",
  location: "Bern, CH",
  email: "info@lt.plus",
  contactEmail: "louis@lt.plus",
  street: "Bolligenstrasse 24A",
  city: "3006 Bern",
  address: "Bolligenstrasse 24A, 3006 Bern",
  coords: "46.9533° N, 7.4658° E",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Bolligenstrasse+24A%2C+3006+Bern",
  uid: "CHE-386.844.826",
  chId: "CH-020-3053402-6",
  ehraId: "1600260",
  github: "https://github.com/louistrue",
  linkedin: "https://www.linkedin.com/in/louistrue",
  tagline: {
    de: "openBIM-Software, offen entwickelt",
    en: "openBIM software, built in the open",
    fr: "Logiciels openBIM, développés en ouvert",
    it: "Software openBIM, sviluppato in aperto",
    rm: "Software openBIM, sviluppada avert",
  },
};

export const LT_TOOLS = [
  {
    key: "ifcLite",
    title: "ifc-lite",
    url: "https://ifclite.com",
    github: "https://github.com/louistrue/ifc-lite",
    description:
      "Browser-native IFC viewer with WebGPU rendering and Rust/WASM parser.",
    tag: "Viewer",
    repo: "louistrue/ifc-lite",
    stars: 162,
    image: "/assets/projectpics/ifclite.jpg",
  },
  {
    key: "ifcRender",
    title: "ifc-render",
    url: "https://ifcrender.com",
    github: null,
    description:
      "AI renderings for any IFC model, powered by nano-banana image generation.",
    tag: "Rendering",
    repo: null,
    stars: null,
    image: "/assets/projectpics/ifcrender.jpg",
    closed: true,
  },
  {
    key: "ifcFlow",
    title: "ifc-flow",
    url: "https://www.ifcflow.com",
    github: "https://github.com/louistrue/ifc-flow",
    description:
      "Visual node-based tool for working with Industry Foundation Classes (IFC) files.",
    tag: "Flow",
    repo: "louistrue/ifc-flow",
    stars: 73,
    image: "/assets/projectpics/ifcflow.jpeg",
  },
  {
    key: "ifcLCA",
    title: "IfcLCA",
    url: "https://www.ifclca.com",
    github: "https://github.com/IfcLCA/IfcLCA",
    description:
      "Open source Life Cycle Assessment for the built environment with IFC.",
    tag: "LCA",
    repo: "IfcLCA/IfcLCA",
    stars: 36,
    image: "/assets/projectpics/ifclca.jpg",
  },
  {
    key: "ifcClassifier",
    title: "ifc-classifier",
    url: "https://www.ifcclassify.com",
    github: "https://github.com/louistrue/ifc-classifier",
    description:
      "Web-based 3D IFC classification editor for Uniclass/eBKP-H references.",
    tag: "Classification",
    repo: "louistrue/ifc-classifier",
    stars: 24,
    image: "/assets/projectpics/ifcclassifier.jpeg",
  },
  {
    key: "idsFlow",
    title: "ids-flow",
    url: "https://www.idslight.com",
    github: "https://github.com/louistrue/ids-flow",
    description:
      "Visual editor for buildingSMART IDS specifications with real-time XML export.",
    tag: "IDS",
    repo: "louistrue/ids-flow",
    stars: 21,
    image: "/assets/projectpics/idslight.jpeg",
  },
  {
    key: "idsEdit",
    title: "ids-edit",
    url: "https://idsedit.com",
    github: null,
    description:
      "Streamlined IDS specification editor for buildingSMART workflows.",
    tag: "IDS",
    repo: null,
    stars: null,
    image: "/assets/projectpics/idsedit.jpg",
    closed: true,
  },
  {
    key: "ifcDataBrowser",
    title: "ifc-data-browser",
    url: "https://ifcsql.com",
    github: "https://github.com/louistrue/ifc-data-browser",
    description:
      "Browse and query IFC building models as SQL databases in your browser — no installation required.",
    tag: "SQL",
    repo: "louistrue/ifc-data-browser",
    stars: 15,
    image: "/assets/projectpics/ifcsql.jpg",
  },
  {
    key: "ifcSite",
    title: "ifc-site",
    url: "https://github.com/louistrue/ifc-site",
    github: "https://github.com/louistrue/ifc-site",
    description:
      "Convert Swiss cadastral parcels into georeferenced 3D IFC models from geo.admin.ch.",
    tag: "GIS",
    repo: "louistrue/ifc-site",
    stars: 12,
    image: "/assets/projectpics/ifcsite.jpg",
  },
  {
    key: "ifcViewGen",
    title: "ifc-view-gen",
    url: "https://github.com/louistrue/ifc-view-gen",
    github: "https://github.com/louistrue/ifc-view-gen",
    description:
      "Generate professional 2D technical drawings from IFC models with SVG export.",
    tag: "Drawings",
    repo: "louistrue/ifc-view-gen",
    stars: null,
    image: "/assets/projectpics/ifcviewgen.jpg",
  },
  {
    key: "ifc5cad",
    title: "ifc5cad",
    url: "https://github.com/louistrue/ifc5cad",
    github: "https://github.com/louistrue/ifc5cad",
    description:
      "Browser-based 3D CAD for authoring IFC5 models using OpenCascade WebAssembly.",
    tag: "Authoring",
    repo: "louistrue/ifc5cad",
    stars: null,
    image: "/assets/projectpics/ifc5cad.jpg",
  },
  {
    key: "llmLcaDemo",
    title: "llm-lca-demo",
    url: "https://github.com/louistrue/llm-lca-demo",
    github: "https://github.com/louistrue/llm-lca-demo",
    description:
      "Interactive LCA calculator matching IFC materials to EPDs via LLM for carbon analysis.",
    tag: "LCA",
    repo: "louistrue/llm-lca-demo",
    stars: null,
    image: "/assets/projectpics/llmlca.jpg",
  },
  {
    key: "agenticBim",
    title: "agentic-bim-team",
    url: "https://github.com/louistrue/agentic-bim-team",
    github: "https://github.com/louistrue/agentic-bim-team",
    description:
      "Multi-agent AI pipeline for Swiss residential building design. Zoning, IFC, specialist agents.",
    tag: "AI",
    repo: "louistrue/agentic-bim-team",
    stars: null,
    image: "/assets/projectpics/agenticbim.jpg",
    imagePosition: "left center",
  },
  {
    key: "ifcxMcp",
    title: "ifcx-mcp",
    url: "https://github.com/louistrue/ifcx-mcp",
    github: "https://github.com/louistrue/ifcx-mcp",
    description:
      "MCP server for authoring IFC5/IFCX models through AI assistants.",
    tag: "MCP",
    repo: "louistrue/ifcx-mcp",
    stars: null,
    image: "/assets/projectpics/ifcxmcp.jpg",
  },
  {
    key: "modelChecker",
    title: "model-checker",
    url: "https://modelcheck.opensource.construction",
    github: "https://github.com/louistrue/model-checker",
    description:
      "Web-based IFC model validator validating against IDS requirements client-side.",
    tag: "Quality",
    repo: "louistrue/model-checker",
    stars: null,
    image: "/assets/projectpics/checker.jpg",
  },
];

/** Tool copy in the active language; the English in LT_TOOLS is the fallback. */
export const toolDescription = (t, tool) =>
  t(`tools.items.${tool.key}.description`, { defaultValue: tool.description });
export const toolTag = (t, tool) =>
  t(`tools.tags.${tool.tag}`, { defaultValue: tool.tag });

export const LT_PROJECTS = [
  {
    id: 1,
    title: "armasuisse BUSA Herisau",
    category: "BIM",
    shortDescription: "BIM Management",
    fullDescription:
      "As a designated BIM Pilot project, this initiative implemented comprehensive coordination processes for armasuisse BUSA Herisau across all project phases. The implementation featured full-scale quality control protocols, standardized information exchange workflows, and meticulous documentation procedures.",
    technologies: ["revit", "ifc", "bimcollab", "python"],
    links: { live: "https://www.ar.admin.ch/de/bim-pilotprojekte" },
    image: "/assets/projectpics/busa.jpg",
  },
  {
    id: 2,
    title: "Rocket & Pi Timber Highrise",
    category: "BIM",
    shortDescription: "BIM to timber production workflow",
    fullDescription:
      "In collaboration with innovative timber construction specialists, this project developed a customized BIM-to-production workflow for pioneering timber highrise projects. The solution bridges the technical gap between architectural & structural models and CNC manufacturing systems through standardized data transformation protocols.",
    technologies: ["revit", "python", "javascript", "ifc"],
    links: { live: "https://pi-zug.ch/" },
    image: "/assets/projectpics/pi-rocket.jpg",
  },
  {
    id: 3,
    title: "IFC Timber Facades / Lignum",
    category: "BIM",
    shortDescription: "Parametric timber facades modelled in Blender",
    fullDescription:
      "In partnership with Lignum (Swiss timber industry association), this project developed standardized IFC-compatible timber facade components using Blender's parametric and native IFC modeling capabilities. The work produced over 100 timber facades while maintaining full IFC standard compliance.",
    technologies: ["blender", "python", "ifc"],
    links: { live: "https://lignumdata.ch/" },
    image: "/assets/projectpics/lignum-profile.jpg",
  },
  {
    id: 4,
    title: "V-Zug Areal Development",
    category: "LCA",
    shortDescription: "17-project sustainability framework through 2045",
    fullDescription:
      "Creation and implementation of a pioneering sustainability framework for the V-Zug Tech Cluster, a development spanning 17 distinct projects through 2045. The framework enables data-driven optimization with projected embodied carbon reductions of approximately 50% compared to conventional approaches.",
    technologies: ["python", "react", "nextjs", "ifc"],
    links: { live: "https://techclusterzug.ch/" },
    image: "/assets/projectpics/tcz.jpg",
  },
  {
    id: 5,
    title: "WaltGalmarini Projects",
    category: "LCA",
    shortDescription: "LCA & BIM support across 10+ major projects",
    fullDescription:
      "In partnership with WaltGalmarini engineering, LTplus AG developed specialized LCA methodologies for structural systems. The methodology enables comparative analysis of material alternatives and has informed critical design decisions on 10+ major projects.",
    technologies: ["python", "react", "revit", "nextjs"],
    links: { live: "https://www.waltgalmarini.ch/" },
    image: "/assets/projectpics/wg.jpg",
  },
  {
    id: 6,
    title: "IfcLCA Platform",
    category: "Software",
    shortDescription: "Integrated BIM-LCA analysis platform",
    fullDescription:
      "This flagship software solution bridges the gap between Building Information Modeling and Life Cycle Assessment through automated quantity takeoff and environmental impact calculation. The system extracts geometric and material data directly from IFC models while applying Swiss-specific environmental impact factors.",
    technologies: ["react", "threejs", "nextjs", "typescript"],
    links: {
      live: "https://www.ifclca.com/",
      github: "https://github.com/IfcLCA/IfcLCA",
    },
    image: "/assets/projectpics/ifclca.jpg",
  },
  {
    id: 7,
    title: "swissLCAdata",
    category: "Software",
    shortDescription: "Swiss-specific environmental impact database",
    fullDescription:
      "Developed out of frustration with the lack of a comprehensive environmental impact database for Switzerland. The database includes all KBOB building materials and components with region-specific impact factors. Features include regular data updates, API access and seamless BIM integration.",
    technologies: ["nodejs", "react", "typescript"],
    links: {
      live: "https://www.lcadata.ch/",
      github: "https://github.com/LTplus-AG/swiss-lca-data",
    },
    image: "/assets/projectpics/lcadata.jpg",
  },
  {
    id: 8,
    title: "openBIM API",
    category: "Software",
    shortDescription: "Interoperable BIM data processing framework",
    fullDescription:
      "This advanced API framework enables automated processing of openBIM models through standardized data extraction, transformation, and analysis protocols. The system supports comprehensive model querying, custom property management, and geometric processing across multiple IFC schema versions.",
    technologies: ["python", "flask", "javascript", "typescript"],
    links: {
      live: "https://openbim-service-production.up.railway.app/docs",
      github: "https://github.com/louistrue/openBIM-service",
    },
    image: "/assets/projectpics/openbim.jpg",
  },
  {
    id: 9,
    title: "Nachhaltigkeitsmonitoring Zurich",
    category: "Software",
    shortDescription: "Sustainability monitoring for the city of Zurich",
    fullDescription:
      "In partnership with Zurich municipal authorities, LT+, Yssential Technologies and ekkodale gmbh developed a comprehensive monitoring system that tracks key sustainability metrics across the city's construction portfolio.",
    technologies: ["vite", "react", "nodejs", "typescript", "python"],
    links: { github: "https://github.com/LTplus-AG/LCA-Cost-NHMzh" },
    image: "/assets/projectpics/zuerich.jpg",
  },
  {
    id: 10,
    title: "Model Checker / Righetti",
    category: "Software",
    shortDescription: "Automated QA for BIM models",
    fullDescription:
      "This open source model checking tool for Righetti Partner Group automates quality assurance checking for BIM models. The system validates models against predefined requirements, ensuring consistency and completeness.",
    technologies: ["vite", "react", "nodejs", "python"],
    links: {
      live: "https://modelcheck.opensource.construction/",
      github: "https://github.com/opensource-construction/model-checker",
    },
    image: "/assets/projectpics/checker.jpg",
  },
];

// Numbers are formatted per language on the sheet; the year stays a string
// so it is never grouped.
export const LT_KPIS = [
  { v: 87, labelKey: "home.kpis.repos" },
  { v: 4067, labelKey: "home.kpis.contributions" },
  { v: 181, labelKey: "home.kpis.followers" },
  { v: "2045", labelKey: "home.kpis.roadmap" },
];

// Every route on the site. `nav` marks the ones in the header strip; the
// footer and the 404 page list them all.
export const LT_ROUTES = [
  { to: "/", key: "navigation.home", nav: true, end: true },
  { to: "/solutions", key: "navigation.solutions", nav: true },
  { to: "/projects", key: "navigation.projects", nav: true },
  { to: "/about", key: "navigation.about", nav: true },
  { to: "/contact", key: "navigation.contact", nav: true },
  { to: "/legal", key: "footer.legalLink", nav: false },
];

// The three IFC scenes drawn on the home sheet, each with its own bearing so
// the same set is never drawn twice alike.
const glb = (name) => `${process.env.PUBLIC_URL}/assets/${name}.glb`;
export const LT_MODELS = {
  bridge: {
    path: glb("infra_data"),
    viewDir: [0.62, 0.42, 0.66],
    titleKey: "home.model1Title",
    metaKey: "home.model1Meta",
  },
  building: {
    path: glb("sample"),
    viewDir: [-0.5, 0.66, 0.56],
    titleKey: "home.model2Title",
    metaKey: "home.model2Meta",
  },
  facade: {
    path: glb("facade"),
    viewDir: [0.72, 0.3, 0.62],
    titleKey: "home.model3Title",
    metaKey: "home.model3Meta",
  },
};
